export function Mind(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 0C2.68629 0 0 2.68629 0 6V18C0 21.3137 2.68629 24 6 24H18C21.3137 24 24 21.3137 24 18V6C24 2.68629 21.3137 0 18 0H6ZM17.6875 16.0266C17.6875 17.0344 17.1719 17.6203 16.2812 17.6203C15.4062 17.6203 14.9375 17.0578 14.9375 16.0266V11.4094H14.7969L13.3359 14.5656C12.9297 15.425 12.6016 15.7063 12.0391 15.7063C11.4609 15.7063 11.1094 15.4016 10.7188 14.5656L9.25781 11.4094H9.10938V16.0266C9.10938 17.0344 8.59375 17.6203 7.70312 17.6203C6.82812 17.6203 6.35938 17.0578 6.35938 16.0266V8.79219C6.35938 7.55782 7.07812 6.8 8.23438 6.8C9.17188 6.8 9.76562 7.25313 10.3047 8.38594L11.9844 11.9953H12.0859L13.7656 8.37032C14.3047 7.2375 14.875 6.8 15.8359 6.8C17.0156 6.8 17.6875 7.52657 17.6875 8.79219V16.0266Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
